import React from 'react'
import {FiChevronRight} from "react-icons/fi";

const SecondSubmenuSide = (props) => {

    const showThirdSubmenuSideHandler = (key) =>
    {
        props.showThirdSubmenuSideHandler(key);
    }

    return (
            <div onMouseLeave={props.hideThirdSubmenuSideHandler} className='h-full overflow-x-hidden' id="containerDivThirdChildSubmenu">
                <div className={props.dropdownThirdSide ? 'border-r-1 border-white' : ''} style={{float: 'left'}} id="divThirdChildSubmenu">
                    <ul className="h-full" style={{paddingRight: "26px"}} >
                        {props.submenus.map((submenu, key) => (
                            <li className="text-xs xl:text-sm 2xl:text-base uppercase text-gray-light pb-2 font-mediumpy-1 w-full ml-4" key={key} >
                                <div className='w-full' id={`menuVoice${key}`}>
                                    {
                                        submenu.submenu ?
                                        <div className='h-full hover:text-red-primary d-flex align-center cursor-pointer' onMouseOver={() => showThirdSubmenuSideHandler(key)}>
                                            <div className='w-11/12 h-full' style={{float: 'left'}}>
                                                <a href={submenu.to} dangerouslySetInnerHTML={{ __html: submenu.title }} className='h-full d-flex items-center' aria-haspopup="menu"></a>
                                            </div>
                                            <div className='w-1/12 h-full' style={{float: 'left'}}>
                                                <FiChevronRight className="m-auto w-full d-flex m-auto text-right cursor-pointer mr-0" style={{justifyContent: 'end', width: '25px', height: '16px'}}/>
                                            </div>
                                        </div>
                                    :
                                        <a href={submenu.to} dangerouslySetInnerHTML={{ __html: submenu.title }} className='h-full d-flex items-center hover:text-red-primary' aria-haspopup="menu"></a>
                                    }
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            );
  };
  
  export default SecondSubmenuSide;